import * as React from 'react';

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import FormControl from '@mui/material/FormControl'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField';

import { ValidateDate, ValidateDateRange } from '../utils/Validator.tsx';

export default function CharismaCertificationForm(props){
    

    const [date, setDate] = React.useState(props.date);
    const [item, setItem] = React.useState(props.item ? props.item : props.items.length > 0 ? props.items[0].id : 0);
    const [validation, setValidation] = React.useState(props.validation ? props.validation : 0);
    const [retake, setRetake] = React.useState(props.retake ? props.retake : false); 
    const [error, setError] = React.useState(0);
    const [wait, setWait] = React.useState(false);

    function handleSubmit(){
                
        let lValid: number = ValidateDate(date);
        let lValidMin = 0;
        let lValidMax = 0;
        if(lValid === 0 ){             
            if(props.minDate !== undefined){           
                lValidMin = ValidateDateRange(props.minDate, date);
                if(lValidMin === 1){
                    setError(2);
                }
            }            
            if(props.maxDate !== undefined){           
                lValidMax = ValidateDateRange(date, props.maxDate);
                if(lValidMin === 1){
                    setError(3);
                }
            }            
        }            
                    
        else{
            setError(1);
        }
         
        if(lValid === 0 && lValidMax === 0 && lValidMin === 0){    
            setWait(true);   
            if(props.id){     
                props.handleSubmit(props.id, date, item, validation, retake ? 1 : 0 );
            }
            else{
                props.handleSubmit(date, item, validation, retake ? 1 : 0 );
            }
        }
    }
    
    return(
        <Dialog
            open={true}
        >
            <DialogTitle>
                Certification
            </DialogTitle>          
            <DialogContent>
                <FormControl fullWidth>
                <InputLabel id="label">Item</InputLabel>
                    <Select
                        labelId="label"
                        id="type-select"
                        value={item}
                        label="Item"
                        onChange={(event)=>setItem(event.target.value)}
                    >
                    {
                        props.items.map((lItem)=>(
                            <MenuItem value={lItem.id}>{lItem.title}</MenuItem> 
                        ))
                    }
                  </Select>
                </FormControl>  
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="date"
                    label="Date du bilan"
                    name="date"
                    InputLabelProps={{ shrink: true, required: true }}
                    type={'date'}
                    error={error > 0}
                    helperText={error === 1 ? 'Date antérieure au début de formation' : error===2 ? 'Date postérieure à la fin de formation' : null}
                    value={date}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setDate(event.target.value);
                    }}
                />      
                <FormControl fullWidth>
                <InputLabel id="label">Validation</InputLabel>
                    <Select
                        labelId="label"
                        id="validation-select"
                        value={validation}
                        label="Validation"
                        onChange={(event)=>setValidation(event.target.value)}
                    >
                        <MenuItem value={0}>Non-Acquis</MenuItem>
                        <MenuItem value={1}>Acquis</MenuItem>
                    
                  </Select>
                </FormControl>                    
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={retake}
                            onClick={
                                (event)=>setRetake(event.target.checked)
                            }
                        />
                        }
                    label="Rattrapage"
                />
            
          
                {wait ?
                    <Alert severity="info">{"Ajout de l'évaluation en cours"}</Alert>
                    :
                    null
                }   
                      
            </DialogContent>
            <DialogActions>
                <Button disabled={wait} onClick={()=>handleSubmit()}>Valider</Button>
                <Button disabled={wait} onClick={()=>props.handleCancel()}>Annuler</Button>
            </DialogActions>
        </Dialog>        
    );
}